import * as constants from './constants'
import { signInWithEmailAndPassword, sendPasswordResetEmail, User } from 'firebase/auth'
import { auth } from 'firebaseConfig/clientApp'
import { signOut } from 'firebase/auth'
import { createUserWithEmailAndPassword, sendEmailVerification } from 'firebase/auth'
import { updateMyProfile } from './profile'
import { AppDispatch, RootState } from 'reducers/store'
import { Profile, ProfileType } from 'types/user'
import { isDev } from 'app/general'
import { generatePassword } from './general'
// import { setStorageObject } from './capacitorStorage'

export const setName = (name: string) => {
  return {
    type: constants.SET_NAME,
    name: name,
  }
}

export const resetUser = () => {
  return async (dispatch: AppDispatch, getState: () => RootState) => {
    dispatch({
      type: constants.RESET_EXPIRATION,
    })
  }
}

export const updateToken = (force?: boolean, passedUser?: User, sender?: string) => {
  return async (dispatch: AppDispatch, getState: () => RootState) => {
    console.log('updateToken')

    // const tokenIsLoading = getState().userReducer.tokenLoading
    const localUser = getState().userReducer.user
    const currentUser = auth.currentUser ?? (passedUser ?? localUser)

    if (!currentUser) {
      //TODO, CHECK IF LOGOUT IS NEEDED
      // await dispatch(logout())
      return
    }

    // if (!force) {
    //   if (tokenIsLoading) {
    //     alert("TOKEN IS LOADING")
    //     return;
    //   }
    //   const expirationTime = getState().userReducer.tokenExpiration;
    //   if (!isLocalTokenExpired(expirationTime)) {
    //     alert('NO NEED TO UPDATE TOKEN')
    //     return
    //   }
    // }

    // dispatch({ type: 'CHECK TOKEN', sender, tokenIsLoading, currentUser })

    // dispatch({ type: constants.UPDATE_TOKEN_TRY })

    try {
      const idToken = await currentUser.getIdToken()
      dispatch({
        type: constants.UPDATE_TOKEN_RESPONSE,
        newAccessToken: idToken,
        user: currentUser,
      })
    } catch (error) {
      isDev && console.log(error)
      dispatch({
        type: constants.UPDATE_TOKEN_ERROR,
        response: {
          error: error
        },
      })
    }
  }
}

export const updateTokenWithUser = (user: User) => {
  return async (dispatch: AppDispatch) => {
    dispatch({ type: constants.UPDATE_TOKEN_TRY })

    try {
      const idToken = await user.getIdToken()
      dispatch({
        type: constants.UPDATE_TOKEN_RESPONSE,
        newAccessToken: idToken,
        user: user,
      })
    } catch (error) {
      isDev && console.log(error)
      dispatch({
        type: constants.UPDATE_TOKEN_ERROR,
        response: {
          error: error
        },
      })
    }
  }
}
export const login = (email: string, password: string) => {
  return async (dispatch: AppDispatch, getState: () => RootState) => {
    dispatch({ type: constants.LOGIN_TRY })
    isDev && console.log('login:', 'LOGIN TRY')

    return signInWithEmailAndPassword(auth as any, email, password)
      .then((userCredential) => {
        isDev && console.log('login:', 'LOGIN RESPONSE', userCredential)
        const user = Object.assign({}, userCredential.user, {})
        //IF USER IS NOT VERIFIED
        if (!user.emailVerified) {
          dispatch({ type: constants.GO_TO_PAGE, page: '/auth/login' })
          dispatch({
            type: constants.LOGIN_ERROR,
            alert: {
              severity: 'info',
              message:
                'Please check your email and find the verification email from brizup!',
            },
          })
          dispatch(logout())
          return false
        }

        dispatch({ type: constants.LOGIN_RESPONSE, user: user })

        //  isDev && console.log("login:", "LOGIN RESPONSE", user)
        // await dispatch(getMyProfile(user))

        // await getMyProfile()(dispatch, getState) //GET MY PROFILE
        // await getMyActivity()(dispatch, getState) //GET MY ACTIVITY
        dispatch({
          type: constants.GO_TO_PAGE,
          page: '/',
        })
        return true

      })
      .catch((error) => {
        isDev && console.log('login:', 'LOGIN ERROR', error)

        dispatch({ type: constants.LOGIN_ERROR, error: error })
        const errorCode = error.code
        const errorMessage = error.message
        return false
      })
    isDev && console.log('login:', 'LOGIN END')
  }
}

export const resetPassword = (email: string, noRedirects?: boolean) => {
  return async (dispatch: AppDispatch) => {
    dispatch({ type: constants.RESET_PASSWORD_TRY })
    sendPasswordResetEmail(auth, email)
      .then(() => {
        if (noRedirects) {
          // dispatch({
          //   type: constants.ADD_ALERT,
          //   alert: {
          //     severity: 'info',
          //     message: 'Please check your email for the password link',
          //   }
          // })
          return
        }
        dispatch({ type: constants.RESET_PASSWORD_RESPONSE })
        dispatch({ type: constants.GO_TO_PAGE, page: '/auth/login' })
      })
      .catch((error) => {
        dispatch({ type: constants.RESET_PASSWORD_ERROR, error: error })
        const errorCode = error.code
        const errorMessage = error.message
      })
  }
}

export const verifyEmail = (dispatch: any, noRedirects?: boolean) => {
  dispatch({ type: constants.SEND_EMAIL_VERIFICATION_TRY })

  sendEmailVerification(auth.currentUser as any)
    .then(() => {
      if (noRedirects) {
        // dispatch({
        //   type: constants.ADD_ALERT,
        //   alert: {
        //     severity: 'info',
        //     message: 'Please check your email for the verification link',
        //   }
        // })
        return
      }
      dispatch({ type: constants.SEND_EMAIL_VERIFICATION_RESPONSE })
      dispatch({ type: constants.GO_TO_PAGE, page: '/auth/login' })
      //  isDev && console.log(user)
    })
    .catch((error) => {
      dispatch({ type: constants.SEND_EMAIL_VERIFICATION_ERROR, error: error })
      const errorCode = error.code
      const errorMessage = error.message
      //  isDev && console.log(error)
    })
}



export const signupWithEmailAndStay = (email: string) => {
  return async (dispatch: any) => {
    dispatch({ type: constants.SIGNUP_TRY })


    const password = generatePassword(12)
    createUserWithEmailAndPassword(auth as any, email, password)
      .then(async (userCredential) => {
        const user = userCredential.user
        dispatch({ type: constants.SIGNUP_RESPONSE, user: user })
        verifyEmail(dispatch, true)
        resetPassword(email, true)(dispatch)

        if (user) {
          dispatch({ type: constants.LOGIN_RESPONSE, user: user })
          dispatch({ type: constants.GO_TO_PAGE, page: '/home' })
        }

      })
      .catch((error) => {
        dispatch({ type: constants.SIGNUP_ERROR, error: error })
        const errorCode = error.code
        const errorMessage = error.message
      })
  }
}
export const signupWithEmailAndPasswordAndStay = (email: string, password: string) => {
  return async (dispatch: any) => {
    dispatch({ type: constants.SIGNUP_TRY })

    createUserWithEmailAndPassword(auth as any, email, password)
      .then(async (userCredential) => {
        const user = userCredential.user
        dispatch({ type: constants.SIGNUP_RESPONSE, user: user })
        verifyEmail(dispatch, true)

        if (user) {
          dispatch({ type: constants.LOGIN_RESPONSE, user: user })
          dispatch({ type: constants.GO_TO_PAGE, page: '/home' })
        }

      })
      .catch((error) => {
        dispatch({ type: constants.SIGNUP_ERROR, error: error })
        const errorCode = error.code
        const errorMessage = error.message
      })
  }
}

export const signupWithEmailAndPassword = (email: string, password: string) => {
  return async (dispatch: any) => {
    dispatch({ type: constants.SIGNUP_TRY })

    createUserWithEmailAndPassword(auth as any, email, password)
      .then(async (userCredential) => {
        const user = userCredential.user
        dispatch({ type: constants.SIGNUP_RESPONSE, user: user })
        verifyEmail(dispatch)

        if (user) {
          await dispatch(logout())
          dispatch({ type: constants.GO_TO_PAGE, page: '/auth/login' })
        }

      })
      .catch((error) => {
        dispatch({ type: constants.SIGNUP_ERROR, error: error })
        const errorCode = error.code
        const errorMessage = error.message
      })
  }
}

export const signup = (name: string, country: string, city: string, email: string, password: string) => {
  return async (dispatch: any) => {
    dispatch({ type: constants.SIGNUP_TRY })

    createUserWithEmailAndPassword(auth as any, email, password)
      .then(async (userCredential) => {
        const user = userCredential.user
        dispatch({ type: constants.SIGNUP_RESPONSE, user: user })
        if (user) {
          const newProfile: Profile = {
            id: user.uid,
            name: name,
            email: email,
            country: country.trim().toLowerCase(),
            city: city.trim().toLowerCase(),
            mobile: '',
            profileType: [ProfileType.Dancer]
          }
          await dispatch(updateMyProfile(newProfile, user, user.uid))
          await dispatch(logout())

          dispatch({ type: constants.GO_TO_PAGE, page: '/auth/login' })
        }
        verifyEmail(dispatch)
      })
      .catch((error) => {
        dispatch({ type: constants.SIGNUP_ERROR, error: error })
        const errorCode = error.code
        const errorMessage = error.message
      })
  }
}

export const logout = (redirectPath?: string) => {
  return async (dispatch: any) => {
    dispatch({
      type: constants.LOGOUT,
      response: { code: 'FORCE_LOGOUT_FRONTEND' },
    })

    if (redirectPath) {
      dispatch({
        type: constants.GO_TO_PAGE,
        page: redirectPath,
      })
    }

    signOut(auth as any)
      .then((userCredential) => {
        dispatch({ type: constants.LOGOUT_RESPONSE })
        // setStorageObject("user", null);
      })
      .catch((error) => {
        dispatch({ type: constants.LOGOUT_ERROR, error: error })
        const errorCode = error.code
        const errorMessage = error.message
      })
  }
}

export const isLocalTokenExpired = (expirationTime?: Date) => {
  // const lastRefresh = state.userReducer.lastRefresh
  isDev && console.log('TOKEN EXPIRATION: expirationTime', expirationTime)
  if (!expirationTime) return true
  isDev && console.log('TOKEN EXPIRATION: Diff', (expirationTime.getTime() - new Date().getTime()))
  if ((expirationTime.getTime() - new Date().getTime()) < 0) {
    isDev && console.log('TOKEN EXPIRED ------')
    return true
  }
  return false
}